import React from 'react';
import { FormFeedback, FormGroup, Input as RInput, Label } from "reactstrap";
import { FieldProps } from 'formik'

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const Input: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { ...fields },
  form: { touched, errors },
  ...props
}) => {
    return (
      <FormGroup>
        {props.label &&
          <Label for={fields.name} className={"label-color"}>
            {props.label}
          </Label>}
        <RInput
          {...props}
          {...fields}
          onChange={e => fields.onChange(e)}
          invalid={Boolean(touched[fields.name] && errors[fields.name])} />
        {touched[fields.name] && errors[fields.name] ? <FormFeedback>{errors[fields.name]}</FormFeedback> : ''}
      </FormGroup>
    );
  };


export default Input;
